import React from "react";
import { Icon } from "@iconify/react";
import { Box, HStack } from "../utils";

type CollapsibleType = {
  label: string;
  labelDetail: string;
  isOpen: boolean;
  onClick: any;
  numberOfItems?: number;
} & React.HTMLAttributes<HTMLElement>;
export function NewCollapsibleComponent(
  props: CollapsibleType
): React.ReactElement {
  const { label, labelDetail, isOpen, onClick, numberOfItems, ...rest } = props;

  return (
    <Box className=" p-4 rounded-sm shadow-lg">
      <Box
        className="flex flex-row  items-center justify-between align-middle cursor-pointer text-center"
        onClick={onClick}
      >
        <HStack className="gap-2 items-center align-middle">
          <Box className="pt-2">
            {isOpen ? (
              <Icon icon="il:arrow-down" height={15} />
            ) : (
              <Icon icon="il:arrow-up" height={15} />
            )}
          </Box>
          <Box className="text-black text-sm font-medium justify-between flex w-full">
            <HStack>{label}</HStack>
          </Box>
        </HStack>
        <HStack>
          <Box className="text-black text-sm font-medium justify-between flex w-full">
            <HStack>
              {numberOfItems !== undefined && (
                <Box className="ml-2 px-3 py-0.5 bg-[#003366] text-white rounded-xl text-xs">
                  {numberOfItems}
                </Box>
              )}
            </HStack>
          </Box>
        </HStack>
      </Box>

      {!isOpen ? (
        <Box className="p-1 border-gray-300  ml-2 mt-2 space-y-2">
          <Box className=" space-y-2">
            <p className="text-[#4E4E4E] text-xs">{labelDetail}</p>
          </Box>
          {props.children}
        </Box>
      ) : (
        ""
      )}
    </Box>
  );
}
